import { useUpdateSoftwareVersionMutation } from "../../api/api-hooks";
import { SoftwareVersionForm } from "./linksTypes";

const useSoftwareVersionUpdater = () => {
  const [editVersion] = useUpdateSoftwareVersionMutation();
  return (item: SoftwareVersionForm, id: number) => {
    return editVersion({
      id: id,
      updateSoftwareVersionDto: {
        id: id,
        versionNumber: item.versionNumber,
        versionType: item.versionType,
        link: item.link,
        changelog: item.changelog ? item.changelog : null,
        size: Number(item.size),
        softwareId: item.software?.id,
        operatingSystemsId: item.operatingSystem?.id,
        userguideLink: item.userguideLink ? item.userguideLink : null,
        userguideName: item.userguideName ? item.userguideName : null,
      },
    });
  };
};

export default useSoftwareVersionUpdater;
